import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "Hent data fra miljø:", -1)
const _hoisted_3 = { class: "flex space-x-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Da vi over tid har ændret hvilke datapunkter, som vi samler ind, er der en risiko for, at sammenblande data fra flere perioder."),
  /*#__PURE__*/_createElementVNode("p", null, "Der findes følgende regler for sammenblanding af data fra forskellige perioder:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "text-sm" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Forløbsdata:"),
      /*#__PURE__*/_createTextVNode(" Historisk data benyttes altid")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Offentlige siders brugsdata:"),
      /*#__PURE__*/_createTextVNode(" Historisk data benyttes aldrig")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Admin-siders brugsdata:"),
      /*#__PURE__*/_createTextVNode(" Historisk data benyttes, hvis denne checkbox "),
      /*#__PURE__*/_createElementVNode("b", null, "ikke"),
      /*#__PURE__*/_createTextVNode(" er markeret")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_CustomCheckbox = _resolveComponent("CustomCheckbox")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_CustomSelect, {
        value: _ctx.chosenDataSource,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenDataSource) = $event)),
        class: "w-64",
        label: _ctx.selectLabel,
        items: _ctx.dataSources,
        "item-text": "text",
        "item-value": "id"
      }, null, 8, ["value", "label", "items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CustomCheckbox, {
        modelValue: (_ctx.chosenApplyDataSource as boolean),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((_ctx.chosenApplyDataSource as boolean)) = $event)),
        label: "Ignorer historisk data"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Popover, { title: "Historisk data" }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "mt-2 border rounded-md bg-white px-4 border-gray-400 py-3",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSaveClicked && _ctx.onSaveClicked(...args)))
    }, "Gem")
  ]))
}